import { Create } from 'react-admin';
import { ScheduleForm } from './Schedule.Form';

export const ScheduleCreate = () => {
    return (
        <Create redirect="list">
            <ScheduleForm />
        </Create>
    );
};
